import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { CardContent, CardHeader, Card } from '@mui/material';
import { Grid, Button, Checkbox } from '@mui/material';
import { Editor } from '@tinymce/tinymce-react';
import { Link } from 'react-router-dom';
import { Edit } from '@mui/icons-material';
import { IconButton, Switch } from '@mui/material';
import TextBox from '../components/_core/Inputs/TextBox';
import CoreGridContainer from '../components/_core/CoreGridContainer';
import CoreGridItem from '../components/_core/CoreGridItem';
import { useHistory } from "react-router-dom";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CoreSpinner from '../components/_core/CoreSpinner';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Row,
  Col,
} from "reactstrap";
import { isAuth, isUserAdmin, isUserSuperadmin } from "../actions/auth";
import { get, post, put, deleteItem } from '../actions/api';
import { resizeFile, convertBase64, getBusiness } from '../actions/helpers';
// import { Prompt } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


function Builder(props) {
  const TINY_API = process.env.REACT_APP_TINY_API;
  // "Generate Documents" opens a template in generation mode: an admin gets the
  // same focused upload -> preview -> print UI a regular user sees, with the
  // template-editing panes hidden. Achieved by treating them as a non-admin here.
  const generateMode = props.location?.state?.generate === true;
  let isAdmin = isUserAdmin() && !generateMode;

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex'
    },
    actionBar: {
      border: '1 solid #ddd'
    },
    upload: {
      display: 'none'
    },
    options: {
      minHeight: 20,
      width: 50
    },
    CardContent: {
      maxHeight: '100%',
      overflow: 'auto'
    },
    card: {
      height: '100%'
    },
    copied: {
      color: 'green',
      fontSize: '13px',
      marginTop: "4px",
      marginBottom: "-39px"
    },
    drawer: {
      width: 200
    },
    divider: {
      paddingTop: 10
    },
    viewer: {
      height: 'calc(160vh - 180px)',
      minHeight: 'calc(130vh - 222px)',
    },
    viewerButtons: {
      paddingLeft: "15px",
      paddingBottom: 10
    },
    file: {
      marginTop: "4px"
    }
  }));

  const history = useHistory();
  const classes = useStyles();
  const [viewer, setViewer] = useState('');
  const [fileError, setFileError] = useState('');
  const [imgError, setImgError] = useState(false);
  const [dataIndex, setDataIndex] = useState(0);
  const [file, setFile] = useState();
  const [data, setData] = useState(null);
  const [fields, setFields] = useState({});
  const [oFields, setOFields] = useState({});
  const [pFields, setPFields] = useState([]);
  const [cFields, setCFields] = useState([]);
  const [value, setValue] = useState('');
  const [visible, setVisible] = useState(false);
  const [notSaved, setNotSaved] = useState(false);
  const [editSection, setEditSection] = useState(true);
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(null);
  const [savedToDb, setSavedToDb] = useState(true);
  const [saving, setSaving] = useState(false);
  const [previewOn, setPreviewOn] = useState(true);
  const [previewed, setPreviewed] = useState(false);
  const [indexes, setIndexes] = useState([]);
  const [autoPrev, setAutoPrev] = useState(false);
  const [dropdownOpenP, setDropdownOpenP] = useState(false);
  const [dropdownOpenC, setDropdownOpenC] = useState(false);
  const [stretch, setstretch] = useState(null);
  const environ = process.env.NODE_ENV;
  const [isDirty, setDirty] = useState(false);
  const [dateField, setDateField] = useState(null);
  const [dateMin, setDateMin] = useState('');
  const [dateMax, setDateMax] = useState('');
  const [fileNameKey, setFileNameKey] = useState('');
  // Configured DB connections for this template (CONFIGURE CONNECTION screen).
  const [connectionOptions, setConnectionOptions] = useState([]);
  const [connDropdownOpen, setConnDropdownOpen] = useState(false);
  useEffect(() => {
    // Detecting browser closing
    window.onbeforeunload = isDirty
      ? () => isDirty
      : null;

    return () => {
      window.removeEventListener('beforeunload', () => {});
    };
  }, [isDirty]);

  // const routerPrompt = <Prompt when={isDirty} message={'Changes that you made may not be saved.'} />;

  if (environ === 'development') {
    window.localStorage.removeItem('refreshDev');
  } else {
    window.localStorage.removeItem('refreshProd');
  };

  const toggleP = () => setDropdownOpenP(prevState => !prevState);
  const toggleC = () => setDropdownOpenC(prevState => !prevState);

  useEffect(() => {
    if (!company) {
      getCompany();
    };
    getTemplateData();
  }, [company, isAdmin, history]);

  // Keep the preview in sync with the selected record whenever the index changes
  // (date-range change, prev/next) — avoids stale reads from setDataIndex + preview().
  useEffect(() => {
    if (file) updateViewer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataIndex]);

  async function getTemplateData() {
    let templateId = null;
    try {
      templateId = props.location.state.id;
    } catch { return };
    if (templateId) {
      const template = await get(`templates/template/${templateId}`);
      setFields(template);
      setOFields(template);
      // updateViewer();
      setNotSaved(false);
      setSavedToDb(true);
      try {
        const options = await get(`connections/options?template_id=${templateId}`);
        setConnectionOptions(options || []);
      } catch {
        setConnectionOptions([]);
      }
    };
  };

  async function getCompany() {
    setLoading(true);
    const companyData = await getBusiness(isUserSuperadmin() && isAuth().business.id);
    const filterKeys = ["id"];
    const companyDataFiltered = Object.fromEntries(Object.entries(companyData).filter(([key]) => !filterKeys.includes(key)));
    setCompany(companyDataFiltered);
    const cKeys = [];
    Object.keys(companyDataFiltered).forEach(function (key) {
      return cKeys.push(key)
    });
    setCFields(cKeys);
    const newData = { company: companyDataFiltered };
    setData(newData);
    updateViewer(null, newData);
    setLoading(false);
  };

  // "Choose JSON File" manual upload removed — template data now comes only from
  // "Load from Database" (loadFromDatabase / data-imports).

  // Legacy path: latest data-import / appsettings warehouse source for this template.
  async function loadFromDatabase() {
    if (!fields.id) return;
    setLoading(true);
    try {
      const importData = await get(`data-imports/latest/${fields.id}`);
      applyImportData(importData);
    } catch (err) {
      catchError(err.response?.data?.error || "Failed to load data import.");
      setLoading(false);
    }
  }

  // Load from a specific CONFIGURE CONNECTION entry (runs its stored query).
  async function loadFromConnection(connectionId) {
    if (!connectionId) return;
    setLoading(true);
    try {
      const importData = await get(`connections/${connectionId}/data`);
      applyImportData(importData);
    } catch (err) {
      catchError(err.response?.data?.error || "Failed to load from connection.");
      setLoading(false);
    }
  }

  // Shared: turn an import payload ({ json_data, file_name, ... }) into builder state.
  function applyImportData(importData) {
    try {
      if (!importData || !importData.json_data) {
        catchError("No data import found for this template.");
        setLoading(false);
        return;
      }
      const fileToJSON = JSON.parse(importData.json_data);
      if (!Array.isArray(fileToJSON)) {
        catchError("Imported data must be a JSON array.");
        setLoading(false);
        return;
      }
      const pKeys = [];
      if (fileToJSON.length > 0) {
        Object.keys(fileToJSON[0]).forEach(key => pKeys.push(key));
      }
      setPFields(pKeys);

      // Date filter operates on the 'reportdate' JSON element specifically. SignOutDate
      // stays in pFields as a document/merge key — this only controls the date filter.
      // Falls back to auto-detecting the first date-like field if 'reportdate' is absent.
      const detectedDateField = pKeys.find(key => key.toLowerCase() === 'reportdate')
        || pKeys.find(key => {
          const lower = key.toLowerCase();
          if (lower.includes('date')) return true;
          const val = fileToJSON[0]?.[key];
          if (val && !isNaN(Date.parse(val)) && isNaN(Number(val))) return true;
          return false;
        });
      setDateField(detectedDateField || null);
      if (detectedDateField) {
        const dateStrings = fileToJSON
          .map(item => toDateOnly(item[detectedDateField]))
          .filter(d => d !== null)
          .sort();
        if (dateStrings.length > 0) {
          setDateMin(dateStrings[0]);
          setDateMax(dateStrings[dateStrings.length - 1]);
        }
      } else {
        setDateMin('');
        setDateMax('');
      }

      setFile({ name: importData.file_name || importData.source_name || 'Database Import' });
      const newData = { company: company || data?.company, patient: fileToJSON.reverse() };
      setData(newData);
      selectAll(fileToJSON.length);
      setPreviewOn(true);
      updateViewer(null, newData, pKeys);
      if (fileError) setFileError(false);
    } catch (err) {
      catchError(err.response?.data?.error || "Failed to load data import.");
    }
    setLoading(false);
  }

  function handleChange(evt, editor) {
    if (editor) {
      setFields({ ...fields, template: editor })
      if (autoPrev) {
        updateViewer(editor);
      };
    } else if (evt) {
      setFields({ ...fields, [evt.target.name]: evt.target.value })
    } else {
      setFields({ ...fields, template: "" })
    };
  };

  async function handleLoad(e) {
    e.preventDefault();
    setLoading(true);
    setImgError(false);
    try {
      const file = e.target.files[0];
      if (file.size > 2000000) {
        return setImgError(true);
      };
      const resizedFile = await resizeFile(file);
      const base64 = await convertBase64(resizedFile);
      setFields({ ...fields, logo: base64 });
    } catch {
      document.getElementById("files").value = "";
    };
    setLoading(false);
    setNotSaved(true);
  };

  function handleOptionChange(e, type) {
    const newValue = e.target.value;
    setValue(newValue);
    if (type === "doc") {
      navigator.clipboard.writeText(`{${newValue}}`);
    } else if (newValue === "Logo") {
      navigator.clipboard.writeText(`{template logo 10}`);
    } else if (newValue === "logo") {
      navigator.clipboard.writeText(`{company.${newValue} 10}`);
    } else {
      navigator.clipboard.writeText(`{${type}${newValue}}`);
    };
    setVisible(type);
  };

  function autoPrevChange() {
    if (!autoPrev) {
      setPreviewOn(true);
      preview(true);
    };
    setAutoPrev(!autoPrev)
  };

  async function prevAndSave() {
    await preview(false);
    saveToDb();
  }

  async function preview(saved) {
    updateViewer();
    setNotSaved(saved);
  };

  function updateViewer(editor, currentDataObj, currentPFields) {
    const d = currentDataObj || data;
    const pf = currentPFields || pFields;
    if (fields) {
      let currentData = editor || fields.template || "";
      for (var cKey in cFields) {
        if (cFields[cKey] !== "logo" && d && d.company) {
          currentData = currentData.replaceAll(`{company.${cFields[cKey]}}`, d.company[cFields[cKey]]);
        }
      };
      for (var pKey in pf) {
        if (d && d.patient && d.patient[dataIndex]) {
          currentData = currentData.replaceAll(`{${pf[pKey]}}`, d.patient[dataIndex][pf[pKey]]);
        }
      };
      if (fields.logo) {
        const logoIndex = currentData.indexOf("{template logo");
        if (logoIndex > -1) {
          const startIndex = logoIndex + 15;
          let index = startIndex;
          let char;
          while (char !== "}" && (index - startIndex) < 4) {
            char = currentData[index];
            index++;
          }
          const size = currentData.slice(startIndex, index-1);
          currentData = currentData.replaceAll(`{template logo ${size}}`, `<img src="${fields.logo}" width="${size}%" alt="" />`);
        }
        currentData = currentData.replaceAll(`{template logo}`, `<img src="${fields.logo}" alt="" />`);
      } else {
        currentData = currentData.replace(/\{template logo[^}]*\}/g, '');
      }
      if (d && d.company) {
        if (d.company.logo) {
          const logoIndex2 = currentData.indexOf("{company.logo");
          if (logoIndex2 > -1) {
            const startIndex2 = logoIndex2 + 14;
            let index2 = startIndex2;
            let char2;
            while (char2 !== "}" && (index2 - startIndex2) < 4) {
              char2 = currentData[index2];
              index2++;
            }
            const size2 = currentData.slice(startIndex2, index2-1);
            currentData = currentData.replaceAll(`{company.logo ${size2}}`, `<img src="${d.company.logo}" width="${size2}%" alt="" />`);
            currentData = currentData.replaceAll(`{company.logo}`, `<img src="${d.company.logo}" alt="" />`);
          }
        } else {
          currentData = currentData.replace(/\{company\.logo[^}]*\}/g, '');
        }
      }
      setViewer(currentData);
    };
  };

  async function saveToDb() {
    if (file || isAdmin || isUserSuperadmin()) {
      setSaving(true);

      if (!fields.created_at) {
        await post("/templates" + (isUserSuperadmin() ? `?business_id=${isAuth().business.id}` : ""), fields)
        setDirty(false);
        history.push("/templates");

      } else {
        const excluded = ["updated_at", "created_at", "business_id"];
        const filteredFields = {};
        for (let [key, value] of Object.entries(fields)) {
          if (!(excluded.includes(key)) && fields[key] !== oFields[key]) {
            filteredFields[key] = value;
          };
        };
        filteredFields["id"] = fields.id;
        await put("/templates", filteredFields)
        setSaving(false);
        setSavedToDb(true);
        setDirty(false);
      }
    };
  };

  function catchError(message) {
    setFileError(message);
    setNotSaved(false);
    setData(null);
    setFile(null);
  };

  // Extract YYYY-MM-DD from any date-ish value, ignoring time/timezone
  function toDateOnly(val) {
    if (!val) return null;
    const s = String(val);
    // If it looks like YYYY-MM-DD or starts with one, use the first 10 chars
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.substring(0, 10);
    const d = new Date(s);
    if (isNaN(d)) return null;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  function filterByDateRange(minDate, maxDate) {
    if (!data || !data.patient || !dateField) return;
    const filtered = [];
    data.patient.forEach((item, index) => {
      const dateOnly = toDateOnly(item[dateField]);
      if (!dateOnly) return;
      if (minDate && dateOnly < minDate) return;
      if (maxDate && dateOnly > maxDate) return;
      filtered.push(index);
    });
    setIndexes(filtered);
    if (filtered.length > 0) {
      setDataIndex(filtered[0]);
      preview(notSaved);
    } else {
      setViewer('');
    }
  }

  function selectAll(len) {
    setIndexes([]);
    if (len) {
      for (var i = 0; i < len; i++) {
        setIndexes((currentIndexes) => [...currentIndexes, i]);
      };
    } else {
      if (data) {
        data.patient.map((item, key) => {
          setIndexes((currentIndexes) => [...currentIndexes, key]);
          return null;
        })
      };
    };
  };

  const Expire = props => {
    useEffect(() => {
      setTimeout(() => {
        setVisible(false);
      }, props.delay);
    }, [props.delay]);

    return visible ? <div>{props.children}</div> : <div />;
  };


  return (
    <div className="content">
      <h3 style={{ marginBottom: 12 }}>{fields.title || "New Template"}</h3>
      {!savedToDb || notSaved ?
        <button style={{ height: 39, marginTop: 5, float: "right" }} className="btn btn-primary" onClick={prevAndSave}>SAVE</button>
        :
        <></>
      }
      <p style={{ marginBottom: 25 }}>{fields.description || "-"}</p>

      {/* <h3 style={{ marginBottom: 12 }}>{fields.title || "New Template"}</h3> */}

      {/* <div  style={{background:'white',display:'flex',justifyContent:'space-between'}}>
      <div  style={styles.Wrapper}>
                    <Col md='5'>
                          <Dropdown style={{ marginLeft: 0 }} value={visible === "company." ? value : ""} isOpen={dropdownOpenC} toggle={toggleC}>
                            <DropdownToggle style={{ padding: "10px 18px 10px 18px",background:'#a74af7' }}>Demographic Keys&nbsp;&nbsp;▼</DropdownToggle>
                            <DropdownMenu
                              modifiers={{
                                setMaxHeight: {
                                  enabled: true,
                                  order: 890,
                                  fn: (data) => {
                                    return {
                                      ...data,
                                      styles: {
                                        ...data.styles,
                                        overflow: 'auto',
                                        maxHeight: 200,
                                      },
                                    };
                                  },
                                },
                              }}
                            >
                              {
                                cFields.map((item, key) =>
                                  <DropdownItem onClick={e => handleOptionChange(e, "company.")} value={item} key={key}>{item}</DropdownItem>
                                )
                              }
                              {
                                fields.logo &&
                                <DropdownItem onClick={e => handleOptionChange(e, "company.")} value={"Logo"} key={"Logo"}>{"Logo"}</DropdownItem>
                              }
                            </DropdownMenu>
                          </Dropdown>
                        </Col>

                        </div>

                        <div style={{marginTop:'-20px'}}> */}
                          
      {fields && (isAdmin || (isUserSuperadmin() && !generateMode)) ?
        <>
          {!editSection ?
            <>
              <IconButton title="Edit" color="primary" style={{ fontSize: 16, marginBottom: 10 }} onClick={() => { setEditSection(true) }}>
                <Edit />&nbsp;Title / Description / Logo
              </IconButton>
            </>
            :
            <Row style={{marginLeft: 6}}>
              <button className="btn btn-secondary" style={{ fontSize: 14, marginBottom: 10, padding: '6px 18px' }} onClick={() => { setEditSection(false) }}>
                Cancel
              </button>
              <CoreGridContainer style={{ marginBottom: 10 }} justifyContent='flex-start'>
                <CoreGridItem xs={6} md={4}>
                  <TextBox
                    required
                    id="title"
                    label="Title"
                    name="title"
                    autoFocus
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => { handleChange(e); setNotSaved(true) }}
                    value={fields.title}
                    inputProps={{ maxLength: 25 }}
                  />
                </CoreGridItem>
                <CoreGridItem xs={6} md={4}>
                  <TextBox
                    required
                    id="description"
                    label="Description"
                    name="description"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => { handleChange(e); setNotSaved(true) }}
                    value={fields.description}
                    inputProps={{ maxLength: 75 }}
                  />
                </CoreGridItem>
              </CoreGridContainer>
              <form>
                <label htmlFor='files' className="btn">Choose a Logo</label>
                <input accept="image/png, image/jpeg" id="files" type="file" onChange={handleLoad} style={{ visibility: "hidden", marginRight: -220 }} />
              </form>
              {fields.logo &&
                <img style={{ marginLeft: 30 }} width="5%" src={fields.logo} alt="Logo" />
              }
              {imgError && <p style={{ marginLeft: 12, marginTop: 11, color: "red" }}>Image file is too big!</p>}
            </Row>
          }
        </>
        :
        null
      }

      {/* </div>
      <div style={{float:'right',margin:'20px'}}>
      {!savedToDb || notSaved ?
        <button style={{ height: 39, marginTop: 5, float: "right" }} className="btn btn-primary" onClick={prevAndSave}>SAVE</button>
        :
        <></>
      }
</div> */}

      {/* </div> */}
      {saving && <CoreSpinner loading={saving} />}
      {!loading ?
        <Grid container spacing={5} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} className={classes.actionBar}>
            {fileError &&
              <div className="alert alert-danger" style={{ marginTop: 10 }} role="alert">
                {fileError}
              </div>
            }
            <Grid style={{ marginTop: 25 }} container spacing={2} alignItems="stretch">
                {/* "Choose JSON File" upload removed — data comes from Load from Database. */}
              {fields.id &&
                <Grid item xs={4} sm={4} md={4} lg={4} style={{ marginTop: 4 }}>
                  {connectionOptions.length > 0 ?
                    <Dropdown isOpen={connDropdownOpen} toggle={() => setConnDropdownOpen(p => !p)} style={{ marginLeft: 8 }}>
                      <DropdownToggle caret style={{ padding: "10px 18px" }}>
                        Load from Database
                      </DropdownToggle>
                      <DropdownMenu style={{ maxHeight: 260, overflowY: 'auto' }}>
                        {connectionOptions.map(opt =>
                          <DropdownItem key={opt.id} onClick={() => loadFromConnection(opt.id)}>
                            {opt.name}
                          </DropdownItem>
                        )}
                      </DropdownMenu>
                    </Dropdown>
                    :
                    <Button
                      variant="outlined"
                      component="span"
                      onClick={loadFromDatabase}
                      style={{ marginLeft: 8 }}
                    >
                      Load from Database
                    </Button>
                  }
                </Grid>
              }
              {file &&
                <Grid className={classes.file} style={{ marginTop: 7 }} item xs={4} sm={4} md={4} lg={4}>
                  File: {file?.name}
                </Grid>
              }
            </Grid>
          </Grid>
          {isAdmin &&
            <Grid item xs={12} md={stretch ? 12 : 6} className={classes.viewer}>
            <Card className={classes.card}>
            { !stretch ?  <IconButton style={{float:'right', margin: 15}} onClick={()=>{ setstretch(1)}}><OpenInFullIcon style={{fontSize: 25}}/></IconButton>  : null }
            { stretch ?  <IconButton style={{float:'right', margin: 15}} onClick={()=>{ setstretch(0)}}><CloseFullscreenIcon style={{fontSize: 30}}/></IconButton>  : null }
              <div style={{ display: "flex", flexDirection: "row" }} >

                <CardHeader title="Builder" />
                {
                  <div style={{ margin: "auto", marginTop: 18 }}>
                    <Row>
                      <FormControlLabel
                        style={{ marginRight: 2 }}
                        control={
                          <Switch
                            checked={autoPrev}
                            onChange={() => { autoPrevChange() }}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        }
                      />
                      <p style={{ color: "black", marginTop: 8 }}>Auto Preview</p>
                    </Row>
                  </div>
                }
              </div>
              <CardContent item xs={12}>
                <Container fluid>
                  <Row>
              { data &&
                        <Col>
                          <Dropdown style={{ marginLeft: 0 }} value={visible === "company." ? value : ""} isOpen={dropdownOpenC} toggle={toggleC}>
                            <DropdownToggle style={{ padding: "10px 18px 10px 18px" }}>Demographic Keys&nbsp;<ExpandMoreIcon style={{fontSize: 26, marginBottom: 2}}/></DropdownToggle>
                            <DropdownMenu
                              modifiers={{
                                setMaxHeight: {
                                  enabled: true,
                                  order: 890,
                                  fn: (data) => {
                                    return {
                                      ...data,
                                      styles: {
                                        ...data.styles,
                                        overflow: 'auto',
                                        maxHeight: 200,
                                      },
                                    };
                                  },
                                },
                              }}
                            >
                              {
                                cFields.map((item, key) =>
                                 item !== "logo" ?
                                  <DropdownItem onClick={e => handleOptionChange(e, "company.")} value={item} key={key}>{item}</DropdownItem>
                                  :
                                  <DropdownItem onClick={e => handleOptionChange(e, "company.")} value={"logo"} key={"logo"}>{"company logo"}</DropdownItem>
                                )
                              }
                              {
                                fields.logo &&
                                <DropdownItem onClick={e => handleOptionChange(e, "company.")} value={"Logo"} key={"Logo"}>{"template logo"}</DropdownItem>
                              }
                            </DropdownMenu>
                          </Dropdown>
                        </Col>
                          }
                                     {file &&
                        <Col>
                          <Dropdown value={visible === "doc" ? value : ""} isOpen={dropdownOpenP} toggle={toggleP}>
                          <DropdownToggle style={{ padding: "10px 24px 10px 24px" }}>Document Keys&nbsp;<ExpandMoreIcon style={{fontSize: 26, marginBottom: 2}}/></DropdownToggle>
                            <DropdownMenu
                              modifiers={{
                                setMaxHeight: {
                                  enabled: true,
                                  order: 890,
                                  fn: (data) => {
                                    return {
                                      ...data,
                                      styles: {
                                        ...data.styles,
                                        overflow: 'auto',
                                        maxHeight: 200,
                                      },
                                    };
                                  },
                                },
                              }}
                            >
                              {
                                pFields.map((item, key) =>
                                  <DropdownItem value={item} key={key} onClick={e => handleOptionChange(e, "doc")}>{item}</DropdownItem>
                                )
                              }
                            </DropdownMenu>
                          </Dropdown>
                        </Col>
                      }
                      
                      {
                        <Col>
                          {!autoPrev &&
                            <>
                              {!previewOn || !previewed ?
                                <button disabled={false} style={{ padding: "10px 18px 10px 18px", marginTop: 4, marginLeft: 0 }} className="btn btn-primary" onClick={() => { preview(true); setPreviewOn(true); setPreviewed(true) }}>PREVIEW</button>
                                :
                                null
                              }
                              {
                                previewed &&
                                <button disabled={true} style={{ padding: "10px 18px 10px 18px", marginTop: 4, marginRight: 0 }} onClick={() => { }} className="btn btn-primary">PREVIEW</button>
                              }
                            </>
                          }
                        </Col>
                      }
                    </Row>

                    <Row>
                      <Col>
                        {visible === "doc" &&
                          <Expire delay="2000">
                            <p className={classes.copied}>Copied!</p>
                          </Expire>
                        }
                      </Col>
                      <Col>
                        {visible === "company." &&
                          <Expire delay="2000">
                            <p className={classes.copied}>Copied!</p>
                          </Expire>
                        }
                      </Col>
                      <Col></Col>
                    </Row>
                  </Container>
                </CardContent>
                <CardContent className={classes.CardContent}>
                  <Grid container spacing={2} direction="column">
                    <Grid item xs={12}>
                      <Editor
                        // disabled={!file}
                        // initialValue={fields.template || ""}
                        editorState={fields.template}
                        apiKey={TINY_API}
                        init={{
                          height: "1000px",
                          lineheight_formats: "1pt 2pt 3pt 4pt 5pt 6pt 7pt 8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 36pt",
                          fontsize_formats: "6pt 7pt 8pt 9pt 10pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 36pt",
                          invalid_elements: 'script[language|type|src]',
                          valid_children: '+body[style]',
                          menubar: true,
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                            'code',
                            'image'
                          ],
                          toolbar: 'undo redo | styleselect fontselect fontsizeselect | forecolor backcolor | code | image |' +
                            'bold italic underline | alignleft aligncenter ' +
                            'alignright alignjustify | bullist numlist outdent indent | lineheight | ' +
                            'removeformat | help',
                          content_style: 'body { font-family: Times New Roman }',
                          contextmenu: "paste | link image inserttable"
                        }}
                        value={fields.template}
                        onEditorChange={(editor) => { setDirty(true); handleChange(false, editor); setNotSaved(true); setPreviewed(false); }}
                        onEditorStateChange={(editor) => { handleChange(false, editor); }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          }
          {
            <Grid item xs={12} md={isAdmin ? 6 : 12} style={{ display: stretch ? 'none':'block', height: 'calc(100vh - 130px)', minHeight: 0 }} className={classes.viewer}>
              <Card className={classes.card} elevation={2} style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
                {/* Fixed control panel — never scrolls; the preview region below has its own scrollbar. */}
                <div style={{ flexShrink: 0, background: '#fff', borderBottom: '2px solid #c5cbd6', boxShadow: '0 6px 10px -4px rgba(0,0,0,0.30)', paddingBottom: 10, marginBottom: 4 }}>
                <CardHeader title="Preview" />
                {file && dateField && data && data.patient &&
                  <Grid item xs={12} style={{ marginTop: 15, padding: '0 20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 13, fontWeight: 600 }}>Filter by {dateField}:</span>
                      <input
                        type="date"
                        value={dateMin}
                        onChange={(e) => {
                          setDateMin(e.target.value);
                          filterByDateRange(e.target.value, dateMax);
                        }}
                        style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc', fontSize: 13 }}
                      />
                      <span style={{ fontSize: 13 }}>to</span>
                      <input
                        type="date"
                        value={dateMax}
                        onChange={(e) => {
                          setDateMax(e.target.value);
                          filterByDateRange(dateMin, e.target.value);
                        }}
                        style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc', fontSize: 13 }}
                      />
                      <button
                        className="btn btn-secondary"
                        style={{ padding: '6px 14px', fontSize: 12 }}
                        onClick={() => {
                          setDateMin('');
                          setDateMax('');
                          selectAll();
                        }}
                      >
                        Clear
                      </button>
                      <span style={{ fontSize: 12, color: '#000', fontWeight: 'bold' }}>
                        {indexes.length} of {data.patient.length} records selected
                      </span>
                    </div>
                  </Grid>
                }
                {file && pFields.length > 0 &&
                  <Grid item xs={12} style={{ marginTop: dateField ? 5 : 15, padding: '0 20px', marginBottom: 5 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 13, fontWeight: 600 }}>File name key:</span>
                      <select
                        value={fileNameKey}
                        onChange={(e) => setFileNameKey(e.target.value)}
                        size={pFields.length > 3 ? 4 : undefined}
                        style={{ padding: '6px 10px', borderRadius: 4, border: '1px solid #ccc', fontSize: 13, maxHeight: 100, overflowY: 'auto' }}
                      >
                        <option value="">Sequential (1, 2, 3...)</option>
                        {pFields.map((key, i) => (
                          <option key={i} value={key}>{key}</option>
                        ))}
                      </select>
                    </div>
                  </Grid>
                }
                {viewer && file && !loading ?
                  <Grid item xs={12} style={{marginTop: 22}} className={classes.viewerButtons}>
                    {(() => {
                      const sortedIdx = [...indexes].sort((a, b) => a - b);
                      const currentPos = sortedIdx.indexOf(dataIndex);
                      const prevIdx = currentPos > 0 ? sortedIdx[currentPos - 1] : (sortedIdx.length > 0 && currentPos === -1 ? sortedIdx[sortedIdx.length - 1] : null);
                      const nextIdx = currentPos >= 0 && currentPos < sortedIdx.length - 1 ? sortedIdx[currentPos + 1] : (sortedIdx.length > 0 && currentPos === -1 ? sortedIdx[0] : null);
                      return (
                        <>
                          <button className="btn btn-secondary" style={{ padding: "8px 16px 8px 16px", color: "white" }} disabled={prevIdx === null} onClick={() => { setDataIndex(prevIdx); preview(notSaved); }}>Previous Page</button>
                          <button className="btn btn-secondary" disabled={nextIdx === null} style={{ marginLeft: "8px", padding: "8px 16px 8px 16px" }} onClick={() => { setDataIndex(nextIdx); preview(notSaved); }}>Next Page</button>
                        </>
                      );
                    })()}

                    <Checkbox checked={indexes.indexOf(dataIndex) > -1} onClick={() => {
                      if (indexes.indexOf(dataIndex) > -1) {
                        setIndexes((currentIndexes) => currentIndexes.filter(function (index) {
                          return index !== dataIndex;
                        }))
                      } else {
                        setIndexes((currentIndexes) => [...currentIndexes, dataIndex]);
                      };
                    }} />
                    <button style={{ marginLeft: "8px", padding: "10px 18px 10px 18px", color: "white" }} disabled={indexes.length === data.patient.length} onClick={() => { dateField ? filterByDateRange(dateMin, dateMax) : selectAll() }} className="btn btn-secondary">Select all</button>
                    <button style={{ marginLeft: "8px", padding: "10px 18px 10px 18px", color: "white" }} disabled={indexes.length < 1} onClick={() => { setIndexes([]) }} className="btn btn-secondary">Deselect all</button>
                    
                    {file && fields &&
                                        <>
                    { !isDirty ? 
                      <Button style={{ marginLeft: "8px", padding: "7px 30px 7px 30px", backgroundColor: "#d34fda", color: "white", fontFamily: 'sans-serif', fontWeight: "700" }} disabled={indexes.length < 1} component={Link} to={{ pathname: "/print", state: { data, template: fields, indexes, printMeta: { fileName: file?.name, dateMin, dateMax, dateField, fileNameKey } } }} className="">PRINT...</Button>
                    :
                    <p style={{fontSize: 12, color: "orange", marginBottom: -20, marginTop: 3}}>Save to print</p>
                    }
                    </>
                  }
                  </Grid>
                  :
                  null
                }
                </div>
                <CardContent style={{ flex: 1, minHeight: 0, padding: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'hidden' }}>
                <iframe title="Preview" srcDoc={viewer} style={{ width: "100%", maxWidth: "816px", height: "100%", flex: 1, border: "1px solid rgb(110, 110, 110, 0.4)"}} />
                </CardContent>
              </Card>
            </Grid>
          }
        </Grid>
        :
        <CoreSpinner loading={loading} />
      }
    </div>
  );
}

export default Builder;
